import * as React from 'react';
import { VerticalBarGraph } from '../../../designSystem/graphs/VerticalBarGraph';
import { SelectionStats } from '../../../amorg-common';
import { colors } from '../../../designSystem/colors/color';

type GroupedAnswerRatioVerticalGraphProps = {
    summaryStats:SelectionStats
}
export function GroupedAnswerRatioVerticalGraph(props:GroupedAnswerRatioVerticalGraphProps):JSX.Element
{
    return (
        <VerticalBarGraph data={[
            { value: props.summaryStats.data.value1Count+props.summaryStats.data.value2Count, color: colors.graphs.survey.answers.veryDissatisfied,
                legendText:<>Uenig eller meget uenig {props.summaryStats.disagreeMinusPct.toFixed(0)}%</>
             },
            { value: props.summaryStats.data.value3Count, color: colors.graphs.survey.answers.neutral,
                legendText:<>Neutral {(props.summaryStats.data.value3Count / props.summaryStats.totalSelections * 100).toFixed(0)}%</>
             },
            { value: props.summaryStats.data.value4Count + props.summaryStats.data.value5Count, color: colors.graphs.survey.answers.verySatisfied,
                legendText:<>Enig eller meget enig {props.summaryStats.agreePlusPct.toFixed(0)}%</>
             },
        ]} barHeightPx={100} heightMode={"total-sum"} />
    );
}